// ============================================
// ROUTES & APP CONSTANTS
// Ported from old/src/common/constants.js
// ============================================

export const ROUTES = {
  MAIN: '/',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  OTP: '/otp',
  RESET_PASSWORD: '/reset-password',
  ENTITY: '/entity',
  ADD_ENTITY: '/entity/add',
  EDIT_ENTITY: '/entity/edit/:id',
  DASHBOARD: '/dashboard',
  SUBSCRIPTION_DASHBOARD: '/subscription-dashboard',
  SUBSCRIPTION_ANALYSIS: '/subscription/analysis',
  ANALYTICS_DASHBOARD: '/analytics/dashboard',
  ANALYTICS_ENGAGEMENT: '/analytics/engagement',
  ANALYTICS_VERSION: '/analytics/version',
  ANALYTICS_PATTERN: '/analytics/pattern',
  ANALYTICS_USER: '/analytics/user/:userId',
  ANALYTICS_INSTITUTE: '/analytics/institute/:instituteId',
  ENTITYTYPE: '/entity-type',

  ADD_ENTITY_TYPE: '/entity-type/add',
  EDIT_ENTITY_TYPE: '/entity-type/edit/:id',
  INDEX_MANAGEMENT: '/index-management',
  SCHOOL_LIST: '/school-list',
  DELETED_SCHOOL_LIST: '/deleted-schools',
  SCHOOL_DETAILS: '/school-list/:id',
  BANNER: '/banner',
  ADD_BANNER: '/banner/add',
  EDIT_BANNER: '/banner/edit/:id',
  ANNOUNCEMENT: '/announcement',
  ADD_ANNOUNCEMENT: '/announcement/add',
  EDIT_ANNOUNCEMENT: '/announcement/edit/:id',
  VIEW_ANNOUNCEMENT: '/announcement/view/:id',
  ADVERTISEMENT: '/advertisement',
  ADD_ADVERTISEMENT: '/advertisement/add',
  EDIT_ADVERTISEMENT: '/advertisement/edit/:id',
  VIEW_ADVERTISEMENT: '/advertisement/view/:id',

  ROLE_PERMISSION: '/roles-and-permission',
  SUB_ADMINS: '/sub-admins',
  ADD_SUB_ADMIN: '/sub-admins/add',
  EDIT_SUB_ADMIN: '/sub-admins/edit/:id',
  MAKE_AN_ANNOUNCEMENT: '/make-an-announcement',
  MAKE_ROLES_AND_PERMISSION: '/roles-and-permission/make-roles-and-permission',
  ANNOUNCEMENT_DETAILS: '/announcement-details/:id',
  INSTITUTE_LIST: '/institute-list',
  DELETED_INSTITUTE_LIST: '/deleted-institutes',
  INSTITUTE_DETAILS: '/institute-list/:id',
  COLLEGE_LIST: '/college-list',
  DELETED_COLLEGE_LIST: '/deleted-colleges',
  COLLEGE_DETAILS: '/college-list/:id',
  HOSPITAL_LIST: '/hospital-list',
  HOSPITAL_DETAILS: '/hospital-list/:id',

  // QA Config
  QA_QUESTION_SOURCE: '/qa-config/question-source',
  QA_ANSWER_SOURCE: '/qa-config/answer-source',
  QA_QUESTION_TYPE: '/qa-config/question-type',
  QA_QUESTION_DIFFICULTY_LEVEL: '/qa-config/question-difficulty-level',
  QA_QUESTION_COGNITIVE_LEVEL: '/qa-config/question-cognitive-level',

  TYPE_MANAGEMENT: '/type-management',
  ADD_TYPE: '/type-management/add',
  EDIT_TYPE: '/type-management/edit/:id',

  SAMPLE_FILES: '/sample-files',
  EDIT_SAMPLE_FILE: '/sample-files/edit/:type',
  PUBLIC_FILES: '/public-files',
  STUDENT_LIST: '/student-list/:id',
  TEACHER_LIST: '/teacher-list/:id',
  INFORMATION: '/information',
  ADD_INFORMATION: '/information/add',
  EDIT_INFORMATION: '/information/edit/:id',
  VIEW_INFORMATION: '/information/view/:id',
  // Keep old routes for backward compatibility if needed by other components
  CREATE_INFORMATION: '/create-information',
  INFORMATION_DETAILS: '/information-details/:id',
  COIN_OFFER: '/coin-offer',
  ADD_COIN_OFFER: '/coin-offer/add',
  EDIT_COIN_OFFER: '/coin-offer/edit/:id',
  COIN_HISTORY: '/coin-history',
  ADD_COIN_HISTORY: '/coin-history/add',
  STORAGE_HISTORY: '/storage-history',
  ADD_STORAGE_HISTORY: '/storage-history/add',
  SUBSCRIPTION_CONFIGURATION: '/subscription-configuration',
  ADD_SUBSCRIPTION_CONFIGURATION: '/subscription-configuration/add',
  EDIT_SUBSCRIPTION_CONFIGURATION: '/subscription-configuration/edit/:id',
  SUBSCRIPTION_CONFIGURATION_HISTORY: '/subscription-configuration/history/:id',

  MODULE_PRICE: '/module-price',
  ADD_MODULE_PRICE: '/module-price/add',
  EDIT_MODULE_PRICE: '/module-price/edit/:id',
  CLOUD_STORAGE: '/cloud-storage',
  ADD_CLOUD_STORAGE: '/cloud-storage/add',
  EDIT_CLOUD_STORAGE: '/cloud-storage/edit/:id',
  SUBSCRIPTION_PLAN: '/subscription-plan',
  VIEW_SUBSCRIPTION_PLAN: '/view-subscription-plan',
  ARENA_SPORTS: '/arena/sports',
  ARENA_SPORTS_ADD: '/arena/sports/add',
  ARENA_SPORTS_EDIT: '/arena/sports/edit/:id',
  ARENA_SPORT_CATEGORIES: '/arena/sport-categories',
  ARENA_SPORT_CATEGORIES_ADD: '/arena/sport-categories/add',
  ARENA_SPORT_CATEGORIES_EDIT: '/arena/sport-categories/edit/:id',
  ARENA_SPORT_SUB_CATEGORIES: '/arena/sport-sub-categories',
  ARENA_SPORT_SUB_CATEGORIES_ADD: '/arena/sport-sub-categories/add',
  ARENA_SPORT_SUB_CATEGORIES_EDIT: '/arena/sport-sub-categories/edit/:id',
  ARENA_SPORT_ROLES: '/arena/sport-roles',
  ARENA_SPORT_ROLES_ADD: '/arena/sport-roles/add',
  ARENA_SPORT_ROLES_EDIT: '/arena/sport-roles/edit/:id',
  ARENA_EQUIPMENTS: '/arena/equipments',
  ARENA_EQUIPMENTS_ADD: '/arena/equipments/add',
  ARENA_EQUIPMENTS_EDIT: '/arena/equipments/edit/:id',
  ARENA_FACILITY_MASTERS: '/arena/facility-masters',
  ARENA_FACILITY_MASTERS_ADD: '/arena/facility-masters/add',
  ARENA_FACILITY_MASTERS_EDIT: '/arena/facility-masters/edit/:id',
  ARENA_FACILITY_MASTERS_LINK_SPORTS: '/arena/facility-masters/:id/link-sports',
  ARENA_FACILITY_AMENITIES: '/arena/facility-amenities',
  ARENA_FACILITY_AMENITIES_ADD: '/arena/facility-amenities/add',
  ARENA_FACILITY_AMENITIES_EDIT: '/arena/facility-amenities/edit/:id',
  ARENA_FACILITY_AMENITIES_LINK_SPORTS: '/arena/facility-amenities/:id/link-sports',
  ARENA_EQUIPMENTS_LINK_SPORTS: '/arena/equipments/:id/link-sports',
  ARENA_UNITS: '/arena/units',
  ARENA_UNITS_ADD: '/arena/units/add',
  ARENA_UNITS_EDIT: '/arena/units/edit/:id',
  ARENA_SKILLS: '/arena/skills',
  ARENA_SKILLS_ADD: '/arena/skills/add',
  ARENA_SKILLS_EDIT: '/arena/skills/edit/:id',
  ARENA_AGE_GROUPS: '/arena/age-groups',
  ARENA_AGE_GROUPS_ADD: '/arena/age-groups/add',
  ARENA_AGE_GROUPS_EDIT: '/arena/age-groups/edit/:id',
  ARENA_SPORT_GROUP_DATA: '/arena/sport-group-data',
  ARENA_SPORT_GROUP_DATA_ADD: '/arena/sport-group-data/add',
  ARENA_SPORT_GROUP_DATA_EDIT: '/arena/sport-group-data/edit/:id',
  ARENA_ASSESSMENT_TESTS: '/arena/assessment-tests',
  ARENA_ASSESSMENT_TESTS_ADD: '/arena/assessment-tests/add',
  ARENA_ASSESSMENT_TESTS_EDIT: '/arena/assessment-tests/edit/:id',
  ARENA_SPORT_INFOS: '/arena/sport-infos',
  ARENA_SPORT_INFOS_ADD: '/arena/sport-infos/add',
  ARENA_SPORT_INFOS_EDIT: '/arena/sport-infos/edit/:id',
  ARENA_ANNOUNCEMENTS: '/arena/announcements',
  ARENA_ANNOUNCEMENTS_ADD: '/arena/announcements/add',
  ARENA_ANNOUNCEMENTS_EDIT: '/arena/announcements/edit/:id',
  ARENA_ANNOUNCEMENTS_VIEW: '/arena/announcements/view/:id',
  PROFILE: '/profile',
  REPORT_COLUMNS: '/report-columns',
  CREATE_REPORT_COLUMNS: '/create-report-columns',
  CERTIFICATES_MANAGEMENT: '/certificates-management',
  ADD_CERTIFICATE: '/certificates-management/add',
  EDIT_CERTIFICATE: '/certificates-management/edit/:id',
  CUSTOM_CERTIFICATES: '/custom-certificates',
  ADD_CUSTOM_CERTIFICATE: '/custom-certificates/add',
  EDIT_CUSTOM_CERTIFICATE: '/custom-certificates/edit/:id',
  USER_LIST: '/user-list',
  TEACHERS_LIST: '/users/teachers',
  STUDENTS_LIST: '/users/students',
  PARENTS_LIST: '/users/parents',
  INSTITUTE_ADMINS_LIST: '/users/institute-admins',
  INSTITUTE_MASTER_ADMINS_LIST: '/users/institute-master-admins',
  SCHOOL_ADMINS_LIST: '/users/school-admins',
  ADMINS_LIST: '/users/admins',
  MASTER_ADMINS_LIST: '/users/master-admins',
  DRIVERS_LIST: '/users/drivers',
  VENDORS_LIST: '/users/vendors',
  SPORT_INSTITUTE_OWNERS_LIST: '/users/sport-institute-owners',
  SPORT_TRAINERS_LIST: '/users/sport-trainers',
  SPORT_ATHLETES_LIST: '/users/sport-athletes',
  DEO_DPEO_LIST: '/users/deo-dpeo',
  DEO_DPEO_STAFF_LIST: '/users/deo-dpeo-staff',
  AGENCY_MASTER_ADMINS_LIST: '/users/agency-master-admins',
  JOB_SEEKERS_LIST: '/users/job-seekers',
  E_LEARNING: '/e-learning',
  CLONE_COURSE: '/clone-course',
  COURSE_INDEX: '/course-index',
  COURSE_PLAN: '/course-plan',
  COURSE_CREATE: '/course-create',
  COURSE_UPLOAD_MATERIAL: '/course-upload-material',
  MERGE_COURSE_CREATE: '/merge-course-create',
  MERGE_COURSE_INDEX: '/merge-course-index',
  MERGE_COURSE_PLAN: '/merge-course-plan',
  SHEET_FIELD: '/sheet-field',
  ADD_SHEET_FIELD: '/sheet-field/add',
  EDIT_SHEET_FIELD: '/sheet-field/edit/:id',
  MAINTENANCE: '/maintenance',

  ADD_MAINTENANCE: '/maintenance/add',
  EDIT_MAINTENANCE: '/maintenance/edit/:id',
  APP_MAINTENANCE: '/maintenance/app/:appType',
  ADD_APP_MAINTENANCE: '/maintenance/app/:appType/add',
  EDIT_APP_MAINTENANCE: '/maintenance/app/:appType/edit/:id',
  ACADEMIC_CALENDAR: '/academic-calendar',
  ADD_ACADEMIC_CALENDAR: '/academic-calendar/add',
  EDIT_ACADEMIC_CALENDAR: '/academic-calendar/edit/:id',
  EDUCATION_OFFICER: '/education-officer',
  ADD_EDUCATION_OFFICER: '/education-officer/add',
  EDIT_EDUCATION_OFFICER: '/education-officer/edit/:id',
  DEO_DPEO: '/deo-dpeo',
  ADD_DEO_DPEO: '/deo-dpeo/add',
  EDIT_DEO_DPEO: '/deo-dpeo/edit/:id',
  KIPIGOVT_ANNOUNCEMENTS: '/kipigovt/announcements',
  KIPIGOVT_ANNOUNCEMENTS_ADD: '/kipigovt/announcements/add',
  KIPIGOVT_ANNOUNCEMENTS_EDIT: '/kipigovt/announcements/edit/:id',
  KIPIGOVT_ANNOUNCEMENTS_VIEW: '/kipigovt/announcements/view/:id',
  VENDOR_ANNOUNCEMENTS: '/vendor/announcements',
  VENDOR_ANNOUNCEMENTS_ADD: '/vendor/announcements/add',
  VENDOR_ANNOUNCEMENTS_EDIT: '/vendor/announcements/edit/:id',
  VENDOR_ANNOUNCEMENTS_VIEW: '/vendor/announcements/view/:id',
  TICKET: '/tickets',
  ADD_TICKET: '/tickets/add',
  EDIT_TICKET: '/tickets/edit/:id',
  TICKET_DETAILS: '/tickets/:id',
  USER_DETAILS: '/users/:id',
  TERMS_AND_CONDITION: '/terms-and-condition',
  ADD_TERMS_AND_CONDITION: '/terms-and-condition/add',
  EDIT_TERMS_AND_CONDITION: '/terms-and-condition/edit/:id',
  VIEW_TERMS_AND_CONDITION: '/terms-and-condition/view/:id',
  ASSIGN_PLAN: '/assign-plan/:id',
  WALLET_HISTORY: '/wallet-history/:id',
  DESIGNATION: '/designation',
  ADD_DESIGNATION: '/designation/add',
  EDIT_DESIGNATION: '/designation/edit',
  NEW_DESIGNATION: '/new-designation',
  ADD_NEW_DESIGNATION: '/new-designation/add',
  EDIT_NEW_DESIGNATION: '/new-designation/edit',
  COMMUNITY_GROUP: '/community-group',
  ADD_COMMUNITY_GROUP: '/community-group/add',
  EDIT_COMMUNITY_GROUP: '/community-group/edit/:id',
  VIEW_COMMUNITY_GROUP: '/community-group/view/:id',
  PERMISSIONS_LIST: '/user-access/permissions',
  CREATE_PERMISSION_CODE: '/user-access/create-permission-code',
  EDIT_PERMISSION_CODE: '/user-access/edit-permission-code/:id',
  ROLE_MANAGEMENT_LIST: '/user-access/role-management',
  CREATE_ROLE_MANAGEMENT: '/user-access/create-role-management',
  EDIT_ROLE_MANAGEMENT: '/user-access/edit-role-management/:id',
  GLOBAL_PERMISSIONS_LIST: '/user-access/global-permissions',
  CREATE_GLOBAL_PERMISSION_CODE: '/user-access/create-global-permission',
  EDIT_GLOBAL_PERMISSION_CODE: '/user-access/edit-global-permission/:id',
  GLOBAL_ROLE_MANAGEMENT_LIST: '/user-access/global-role-management',
  CREATE_GLOBAL_ROLE_MANAGEMENT: '/user-access/create-global-role',
  EDIT_GLOBAL_ROLE_MANAGEMENT: '/user-access/edit-global-role/:id',
  APP_PERMISSIONS_LIST: '/app-permissions/:appType',
  APP_CREATE_PERMISSION: '/app-permissions/:appType/create',
  APP_EDIT_PERMISSION: '/app-permissions/:appType/edit/:id',
  APP_ROLE_MANAGEMENT_LIST: '/app-roles/:appType',
  APP_CREATE_ROLE: '/app-roles/:appType/create',
  APP_EDIT_ROLE: '/app-roles/:appType/edit/:id',
  DYNAMIC_VARIABLE: '/dynamic-variable',
  ADD_DYNAMIC_VARIABLE: '/dynamic-variable/add',
  EDIT_DYNAMIC_VARIABLE: '/dynamic-variable/edit/:id',
  DYNAMIC_VARIABLE_LABEL: '/dynamic-variable-label',
  ADD_DYNAMIC_VARIABLE_LABEL: '/dynamic-variable-label/add',
  EDIT_DYNAMIC_VARIABLE_LABEL: '/dynamic-variable-label/edit/:id',
  KIPIVERSE_INQUIRYS: '/kipiverse-inquirys',
  EDIT_KIPIVERSE_INQUIRY: '/kipiverse-inquirys/edit/:id',
  APPLICATION_MANAGEMENT: '/application-management',
  UPLOAD_APK: '/application-management/upload',
  MODULE_DOC_AI: '/module-doc-ai',
  ADD_MODULE_DOC_AI: '/module-doc-ai/add',
  EDIT_MODULE_DOC_AI: '/module-doc-ai/edit/:id',
  FRC_DOCS: '/frc-docs',
  ADD_FRC_DOC: '/frc-docs/add',
  EDIT_FRC_DOC: '/frc-docs/edit/:id',
  MARKETPLACE_ADD_CATEGORY: '/marketplace/add-category',
  MARKETPLACE_ATTRIBUTE: '/marketplace/attribute',
  MARKETPLACE_ATTRIBUTE_ADD: '/marketplace/attribute/add',
  MARKETPLACE_ATTRIBUTE_EDIT: '/marketplace/attribute/edit/:id',
  MARKETPLACE_COMPANY_APPROVAL: '/marketplace/company-approval-req',
  TEPDS_CATEGORY: '/tepds/category',
  TEPDS_CATEGORY_ADD: '/tepds/category/add',
  TEPDS_CATEGORY_EDIT: '/tepds/category/edit/:id',
  TEPDS_RATING_SCALES: '/tepds/rating-scales',
  TEPDS_RATING_SCALES_ADD: '/tepds/rating-scales/add',
  TEPDS_RATING_SCALES_EDIT: '/tepds/rating-scales/edit/:id',
  TEPDS_TEMPLATES: '/tepds/evaluation-templates',
  TEPDS_TEMPLATES_ADD: '/tepds/evaluation-templates/add',
  TEPDS_TEMPLATES_EDIT: '/tepds/evaluation-templates/edit/:id',
  TEPDS_TEMPLATE_BUILDER: '/tepds/evaluation-templates/:id/manage',
  TEPDS_TEMPLATE_MAPS: '/tepds/template-maps',
  TEPDS_TEMPLATE_MAPS_ADD: '/tepds/template-maps/add',
  TEPDS_TEMPLATE_MAPS_EDIT: '/tepds/template-maps/edit/:id',
  TEPDS_WEIGHT_CONFIGS: '/tepds/weight-configurations',
  TEPDS_WEIGHT_CONFIGS_ADD: '/tepds/weight-configurations/add',
  TEPDS_WEIGHT_CONFIGS_EDIT: '/tepds/weight-configurations/edit/:id',

  // ── Accounting Configuration ───────────────────────────────────
  ACCOUNTING_FINANCIAL_YEARS: '/accounting-configuration/financial-years',
  ACCOUNTING_FINANCIAL_YEARS_ADD: '/accounting-configuration/financial-years/add',
  ACCOUNTING_FINANCIAL_YEARS_EDIT: '/accounting-configuration/financial-years/edit/:id',

  ACCOUNTING_VOUCHER_TYPES: '/accounting-configuration/voucher-types',
  ACCOUNTING_VOUCHER_TYPES_ADD: '/accounting-configuration/voucher-types/add',
  ACCOUNTING_VOUCHER_TYPES_EDIT: '/accounting-configuration/voucher-types/edit/:id',

  ACCOUNTING_ACCOUNT_GROUPS: '/accounting-configuration/account-groups',
  ACCOUNTING_ACCOUNT_GROUPS_ADD: '/accounting-configuration/account-groups/add',
  ACCOUNTING_ACCOUNT_GROUPS_EDIT: '/accounting-configuration/account-groups/edit/:id',

  ACCOUNTING_ACCOUNT_LEDGERS: '/accounting-configuration/account-ledgers',
  ACCOUNTING_ACCOUNT_LEDGERS_ADD: '/accounting-configuration/account-ledgers/add',
  ACCOUNTING_ACCOUNT_LEDGERS_EDIT: '/accounting-configuration/account-ledgers/edit/:id',

  ACCOUNTING_JOURNAL_MAPPINGS: '/accounting-configuration/journal-mappings',
  ACCOUNTING_JOURNAL_MAPPINGS_ADD: '/accounting-configuration/journal-mappings/add',
  ACCOUNTING_JOURNAL_MAPPINGS_EDIT: '/accounting-configuration/journal-mappings/edit/:id',

  ACCOUNTING_COST_CENTERS: '/accounting-configuration/cost-centers',
  ACCOUNTING_COST_CENTERS_ADD: '/accounting-configuration/cost-centers/add',
  ACCOUNTING_COST_CENTERS_EDIT: '/accounting-configuration/cost-centers/edit/:id',


  // ── Master Settings ───────────────────────────────────────────
  MASTER_SETTINGS: '/master-settings',
  ADD_MASTER_SETTING: '/master-settings/add',
  EDIT_MASTER_SETTING: '/master-settings/edit/:id',

  // ── Approvals ──────────────────────────────────────────────────
  APPROVAL_SCHOOLS: '/approvals/schools',
  APPROVAL_SCHOOL_DETAILS: '/approvals/schools/:id',
  APPROVAL_INSTITUTES: '/approvals/institutes',
  APPROVAL_INSTITUTE_DETAILS: '/approvals/institutes/:id',
  APPROVAL_COLLEGES: '/approvals/colleges',
  APPROVAL_COLLEGE_DETAILS: '/approvals/colleges/:id',
  APPROVAL_TEACHERS: '/approvals/teachers',
  APPROVAL_TEACHER_DETAILS: '/approvals/teachers/:id',
  APPROVAL_STUDENTS: '/approvals/students',
  APPROVAL_STUDENT_DETAILS: '/approvals/students/:id',
  APPROVAL_SPORTS_ACADEMIES: '/approvals/sports-academies',
  APPROVAL_SPORTS_ACADEMY_DETAILS: '/approvals/sports-academies/:id',
  APPROVAL_TRAINERS: '/approvals/trainers',
  APPROVAL_TRAINER_DETAILS: '/approvals/trainers/:id',
  APPROVAL_ATHLETES: '/approvals/athletes',
  APPROVAL_ATHLETE_DETAILS: '/approvals/athletes/:id',
  APPROVAL_COMPANIES: '/approvals/companies',
  APPROVAL_COMPANY_DETAILS: '/approvals/companies/:id',
  MARKETPLACE_COMPANY_APPROVAL_DETAILS: '/marketplace/company-approval-req/:id',
  APPROVAL_AGENCIES: '/approvals/agencies',
  APPROVAL_AGENCY_DETAILS: '/approvals/agencies/:id',
  APPROVAL_HOSPITALS: '/approvals/hospitals',
  APPROVAL_HOSPITAL_DETAILS: '/approvals/hospitals/:id',
  APPROVAL_SPORTS_AMENITIES: '/approvals/sports-amenities',
  APPROVAL_SPORTS_AMENITY_DETAILS: '/approvals/sports-amenities/:id',
  EXPO: '/expo',
  ADD_EXPO: '/expo/add',
  EDIT_EXPO: '/expo/edit/:id',
  VIEW_EXPO: '/expo/view/:id',
  EXPO_STAFF: '/expo/staff/:id',
  EXPO_GRID: '/expo-grid',
  EXPO_STALL: '/expo-stall',
  ADD_EXPO_STALL: '/expo-stall/add',
  EDIT_EXPO_STALL: '/expo-stall/edit/:id',
  VIEW_EXPO_STALL: '/expo-stall/view/:id',
  EXPO_STAGE_SLOT: '/expo-stage-slot',
  ADD_EXPO_STAGE_SLOT: '/expo-stage-slot/add',
  EDIT_EXPO_STAGE_SLOT: '/expo-stage-slot/edit/:id',
  THEME: '/theme',
  ADD_THEME: '/theme/add',
  EDIT_THEME: '/theme/edit/:id',
  VIEW_THEME: '/theme/view/:id',
} as const;

export enum KIPIVERSE_INQUIRY_STATUS {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETE = 'COMPLETE',
}

export enum KIPIVERSE_INQUIRY_MSG_FROM {
  KIPI_VERSE = 'KIPI_VERSE',
  EDZYME_TECH = 'EDZYME_TECH',
}

export type RouteKey = keyof typeof ROUTES;

/* Authentication storage keys */
export const TOKEN = 'TOKEN';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const TOKEN_EXPIRY = 'TOKEN_EXPIRY';
export const REFRESH_TOKEN_EXPIRY = 'REFRESH_TOKEN_EXPIRY';
export const USER = 'USER';
export const OTP_VERIFICATION_TOKEN = 'OTP_VERIFICATION_TOKEN';
export const SELECTED_INSTITUTE = 'SELECTED_INSTITUTE';

/* Ticket status constants */
export const TICKET_RAISE_STATUS = {
  OPEN: 'OPEN',
  IN_PROGRESS: 'IN_PROGRESS',
  RESOLVED: 'RESOLVED',
  CLOSED: 'CLOSED',
} as const;

export type TicketStatus = (typeof TICKET_RAISE_STATUS)[keyof typeof TICKET_RAISE_STATUS];

/* Ticket priority */
export const TICKET_RAISE_PRIORITY = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
} as const;

export type TicketPriority = (typeof TICKET_RAISE_PRIORITY)[keyof typeof TICKET_RAISE_PRIORITY];

/* User types */
export const USER_CREATE_TYPE = {
  // MASTER_ADMIN: 'MASTER_ADMIN',
  ADMIN: 'ADMIN',
  INSTITUTE_MASTER_ADMIN: 'INSTITUTE_MASTER_ADMIN',
  INSTITUTE_ADMIN: 'INSTITUTE_ADMIN',
  TEACHER: 'TEACHER',
  STUDENT: 'STUDENT',
  PARENTS: 'PARENTS',
  DEO_DPEO:'DEO_DPEO'
} as const;

export enum DESIGNATION_TYPE {
  TEACHING_STAFF = 'TEACHING_STAFF',
  NON_TEACHING_STAFF = 'NON_TEACHING_STAFF',
  MANAGEMENT_STAFF = 'MANAGEMENT_STAFF',
  STUDENT = 'STUDENT',
  PARENTS = 'PARENTS',
}

export type UserType = (typeof USER_CREATE_TYPE)[keyof typeof USER_CREATE_TYPE];

/* Application Types */
export const APP_TYPES = [
  { value: 'SCHOOL_APP', label: 'School App' },
  { value: 'INSTITUTE_APP', label: 'Institute App' },
  { value: 'STUDENT_APP', label: 'Student App' },
  { value: 'COLLEGE_APP', label: 'College App' },
    { value: 'KIPIGOVT_APP', label: 'Goverment App' },
  { value: 'GLOBAL_APP', label: 'Global App' },
] as const;

export type AppType = (typeof APP_TYPES)[number]['value'];

/* Pagination */
export const DEFAULT_PAGE_LIMIT = 10;
export const DEFAULT_PAGE = 1;

/* Maintenance */
export const MAINTENANCE_MODE = {
  WEB: 'WEB',
  MOBILE: 'MOBILE',
} as const;

export const MAINTENANCE_TYPE = {
  MAINTENANCE_MODE: 'MAINTENANCE_MODE',
  MAINTENANCE_CONSTRUCTION: 'MAINTENANCE_CONSTRUCTION',
} as const;

export const MAINTENANCE_MODULE_NAME = {
  EXAMS_AND_RESULTS: 'EXAMS_AND_RESULTS',
  ATTENDANCE: 'ATTENDANCE',
  STUDENTS_LIST: 'STUDENT"S_LIST',
  BATCH_MANAGEMENT: 'BATCH_MANAGEMENT',
  INSTITUTE_LESSON_PLAN: 'INSTITUTE_LESSON_PLAN',
  BATCH_WISE_STUDY_PLAN: 'BATCH_WISE_STUDY_PLAN',
  IMPORT_STUDENT: 'IMPORT_STUDENT',
  TEACHERS_LIST: 'TEACHER"S_LIST',
  DIVISION_MANAGEMENT: 'DIVISION_MANAGEMENT',
  SCHOOL_LESSON_PLAN: 'SCHOOL_LESSON_PLAN',
  OPTIONAL_SUBJECT_ALLOCATION: 'OPTIONAL_SUBJECT_ALLOCATION',
  CLASS_ROOM: 'CLASS_ROOM',
  DIVISION: 'DIVISION',
  BANK_ACCOUNT: 'BANK_ACCOUNT',
  LINK_ACCOUNT: 'LINK_ACCOUNT',
  FEES_TYPES: 'FEES_TYPES',
  SUBJECT_MANAGEMENT: 'SUBJECT_MANAGEMENT',
  STAFF_TIMING: 'STAFF_TIMING',
  TIME_MANAGEMENT: 'TIME_MANAGEMENT',
  HOLI_DAY: 'HOLI_DAY',
  EVENT: 'EVENT',
  LECTURE_PLANNER: 'LECTURE_PLANNER',
  FEES_COLLECTION: 'FEES_COLLECTION',
  PDC_CHEQUE: 'PDC_CHEQUE',
  FEES_HISTORY: 'FEES_HISTORY',
  ADD_STUDENTS: 'ADD_STUDENTS',
  ADD_TEACHERS: 'ADD_TEACHERS',
  MANAGE_STUDENTS: 'MANAGE_STUDENTS',
  MANAGE_TEACHERS: 'MANAGE_TEACHERS',
  MANAGE_PARENT: 'MANAGE_PARENT',
  MANGE_ADMINISTRATIVE_STAFF: 'MANGE_ADMINISTRATIVE_STAFF',
  EXAMS: 'EXAMS',
  RESULTS: 'RESULTS',
  STAFF_ATTENDANCE: 'STAFF_ATTENDANCE',
  PAYOUT: 'PAYOUT',
  SALARIES: 'SALARIES',
  LEAVE_TYPE: 'LEAVE_TYPE',
  LEAVE_REQUEST: 'LEAVE_REQUEST',
  LEAVE_HISTORY: 'LEAVE_HISTORY',
  LOG_BOOK: 'LOG_BOOK',
  MASTER_TIMETABLE: 'MASTER_TIMETABLE',
  VENDOR: 'VENDOR',
  PRODUCT_LIST: 'PRODUCT_LIST',
  PURCHASE: 'PURCHASE',
  PRODUCT_CATEGORY_SUBCATEGORY: 'PRODUCT_CATEGORY_SUBCATEGORY',
  INVENTORY_CATEGORY: 'INVENTORY_CATEGORY',
  INVENTORY_LIST: 'INVENTORY_LIST',
  ASSIGN_INVENTORY: 'ASSIGN_INVENTORY',
  RETURN_INVENTORY: 'RETURN_INVENTORY',
  DEAD_STOCK_LIST: 'DEAD_STOCK_LIST',
  ACADEMIC_CALENDAR: 'ACADEMIC_CALENDAR',
  ANNOUNCEMENT: 'ANNOUNCEMENT',
  POLL: 'POLL',
  APPOINTMENTS: 'APPOINTMENTS',
  INQUIRY: 'INQUIRY',
  JOB_APPLICATION: 'JOB_APPLICATION',
  TASK_MANAGEMENT: 'TASK_MANAGEMENT',
  TYPE_MANAGEMENT: 'TYPE_MANAGEMENT',
  BANNERS: 'BANNERS',
  PHOTO_GALLERY: 'PHOTO_GALLERY',
  FEED_BACK: 'FEED_BACK',
  TO_DO: 'TO_DO',
  BIRTH_DAY_LIST: 'BIRTH_DAY_LIST',
  LOST_FOUND: 'LOST_FOUND',
  RULES_REGULATION: 'RULES_REGULATION',
  SITTING_ARRANGEMENT: 'SITTING_ARRANGEMENT',
  VEHICLE_MANAGEMENT: 'VEHICLE_ MANAGEMENT',
  DRIVER_MANAGEMENT: 'DRIVER_MANAGEMENT',
  TRIP_MANAGEMENT: 'TRIP_MANAGEMENT',
  SCHOOL_PROFILE: 'SCHOOL_PROFILE',
  USER_PROFILE: 'USER_PROFILE',
  SCHOOL_INFO_SEVEN_STEPS: 'SCHOOL_INFO_SEVEN_STEPS',
  TESTIMONIALS: 'TESTIMONIALS',
  ACADEMIC_DETAILS_EDITING: 'ACADEMIC_DETAILS_EDITING',
  ACADEMIC_YEAR: 'ACADEMIC_YEAR',
  CANTEEN: 'CANTEEN',
  TIME_TABLE: 'TIME_TABLE',
  MODULE_DASHBOARDS: 'MODULE_DASHBOARDS',
  QUICK_ACTIONS: 'QUICK_ACTIONS',
  FEES_COLLECTION_CARDS: 'FEES_COLLECTION_CARDS',
  UPCOMING_SCHEDULES: 'UPCOMING_SCHEDULES',
  REGISTER_NEW_SCHOOLS: 'REGISTER_NEW_SCHOOLS',
  DRAG_DROP: 'DRAG_DROP',
  ASSIGN_ROLL_NUMBERS: 'ASSIGN_ROLL_NUMBERS',
  BOOK_ASSESSMENT: 'BOOK_ASSESSMENT',
  PROJECT_ASSESSMENT: 'PROJECT_ASSESSMENT',
  HOME_WORK: 'HOME_WORK',
  SYLLABUS: 'SYLLABUS',
  OPTIONAL_SUBJECTS: 'OPTIONAL_SUBJECTS',
  CLASS_TEACHER: 'CLASS_TEACHER',
  IMPORT_STUDENTS: 'IMPORT_STUDENTS',
  CURRICULUM: 'CURRICULUM',
  CURRICULUM_BUILDER: 'CURRICULUM_BUILDER',
  COURSE_ASSIGNMENT: 'COURSE_ASSIGNMENT',
  SHARED_INDEX: 'SHARED_INDEX',
  TEACHER_SUBJECT_INDEX: 'TEACHER_SUBJECT_INDEX',
  DIVISION_WISE_STUDY_PLAN: 'DIVISION_WISE_STUDY_PLAN',
  EXPORT_SERVICES: 'EXPORT_SERVICES',
  REPORTS: 'REPORTS',
  CAMPUS_CARNIVALS: 'CAMPUS_CARNIVALS',
  THEME: 'THEME',
  CREATE_NEW_ROLE: 'CREATE_NEW_ROLE',
  UPLOAD_FILES: 'UPLOAD_FILES',
  ADD_CHAPTERS_TOPIC_SUBTOPICS_INDEX: 'ADD_CHAPTERS_TOPIC_SUBTOPICS_INDEX',
  PLAN_ACTIVATION: 'PLAN_ACTIVATION',
  COINS_PURCHASE: 'COINS_PURCHASE',
  PAYMENT_HISTORY: 'PAYMENT_HISTORY',
  LANGUAGE_SELECTION: 'LANGUAGE_SELECTION',
  GREETINGS: 'GREETINGS',
  PLANNER: 'PLANNER',
  SCHOOL_DIRECTORY: 'SCHOOL_DIRECTORY',
  VIRTUAL_ID_CARD: 'VIRTUAL_ID_CARD',
  NOTIFICATION: 'NOTIFICATION',
  HALL_TICKET: 'HALL_TICKET',
  STORAGE_PURCHASE: 'STORAGE_PURCHASE',
  SHARE_STORAGE: 'SHARE_STORAGE',
  JOINING_REQUEST_TEACHER_STUDENT: 'JOINING_REQUEST_TEACHER_STUDENT',
  SUBJECT_WISE_FEES: 'SUBJECT_WISE_FEES',
  OFFERS: 'OFFERS',
  DISCOUNT: 'DISCOUNT',
  FEES_REMINDER: 'FEES_REMINDER',
  DEAD_STOCK: 'DEAD_STOCK',
  USER_ROLE_MANAGEMENT: 'USER_ROLE_MANAGEMENT',
  PAYMENT_GATEWAY: 'PAYMENT_GATEWAY',
  CERTIFICATE_GENERATION: 'CERTIFICATE_GENERATION',
  WORKING_DAYS: 'WORKING_DAYS',
  ACADEMIC_MANAGEMENT: 'ACADEMIC_MANAGEMENT',
  KIPI_STORAGE: 'KIPI_STORAGE',
  ID_CARD: 'ID_CARD',
  BLOG: 'BLOG',
  QR_CODE_SCANNER: 'QR_CODE_SCANNER',
} as const;

/* Sort order */
export const ORDER = [
  { name: 'Ascending', value: 'ASC' },
  { name: 'Descending', value: 'DESC' },
] as const;

/* Gender */
export const GENDER = [
  { name: 'Female', value: 'FEMALE' },
  { name: 'Male', value: 'MALE' },
  { name: 'Other', value: 'OTHER' },
] as const;

/* Regex patterns */
export const REGEX = {
  NAME: /^[a-z ,.'-]+$/i,
  ZIPCODE: /^[0-9]{5,6}$/,
  PASSWORD: /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#$%^&*]{8,16}$/,
  PHONE: /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
  EMAIL:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  NUMBER: /^\d+$/,
};

/* External applications linked from the sidebar */
export const EXTERNAL_LINKS = {
  AI_ADMIN: 'https://ai.admin.sarvopariapp.com/login',
} as const;

export const FRC_DOC_TYPES = {
  NEED_APPROVAL: 'NEED_APPROVAL',
  NOT_NEED_APPROVAL: 'NOT_NEED_APPROVAL',
} as const;

export type FrcDocType = (typeof FRC_DOC_TYPES)[keyof typeof FRC_DOC_TYPES];

export const DYNAMIC_APPTYPE = {
  INSTITUTE_APP: 'INSTITUTE_APP',
  SCHOOL_APP: 'SCHOOL_APP',
  GLOBAL_APP: 'GLOBAL_APP',
  STUDENT_APP: 'STUDENT_APP',
  VENDOR_APP: 'VENDOR_APP',
  ARENA_APP: 'ARENA_APP',
  COLLEGE_APP: 'COLLEGE_APP',
  ALUMNI_APP: 'ALUMNI_APP',
  KIPIGOVT_APP: 'KIPIGOVT_APP',
  DOCTOR_APP: 'DOCTOR_APP',
  ADMISSIONS_AGENCY_APP: 'ADMISSIONS_AGENCY_APP',
  EXPO_APP: 'EXPO_APP',
} as const;

export type DynamicAppType = (typeof DYNAMIC_APPTYPE)[keyof typeof DYNAMIC_APPTYPE];

export const DYNAMIC_APPTYPE_OPTIONS = [
  { value: DYNAMIC_APPTYPE.INSTITUTE_APP, label: 'Institute App' },
  { value: DYNAMIC_APPTYPE.SCHOOL_APP, label: 'School App' },
  { value: DYNAMIC_APPTYPE.GLOBAL_APP, label: 'Global App' },
  { value: DYNAMIC_APPTYPE.STUDENT_APP, label: 'Student App' },
  { value: DYNAMIC_APPTYPE.VENDOR_APP, label: 'Vendor App' },
  { value: DYNAMIC_APPTYPE.ARENA_APP, label: 'Arena App' },
  { value: DYNAMIC_APPTYPE.COLLEGE_APP, label: 'College App' },
  { value: DYNAMIC_APPTYPE.ALUMNI_APP, label: 'Alumni App' },
  { value: DYNAMIC_APPTYPE.KIPIGOVT_APP, label: 'Kipigovt App' },
  { value: DYNAMIC_APPTYPE.DOCTOR_APP, label: 'Doctor App' },
  { value: DYNAMIC_APPTYPE.ADMISSIONS_AGENCY_APP, label: 'Admission Agency App' },
  { value: DYNAMIC_APPTYPE.EXPO_APP, label: 'Expo App' },
] as const;

export const USER_TYPE = {
  MASTER_ADMIN: 'MASTER_ADMIN',
  ADMIN: 'ADMIN',
  INSTITUTE_MASTER_ADMIN: 'INSTITUTE_MASTER_ADMIN',
  INSTITUTE_ADMIN: 'INSTITUTE_ADMIN',
  TEACHER: 'TEACHER',
  STUDENT: 'STUDENT',
  PARENTS: 'PARENTS',
  DRIVER: 'DRIVER',
  VENDOR: 'VENDOR',
  SPORT_INSTITUTE_OWNER: 'SPORT_INSTITUTE_OWNER',
  SPORT_TRAINER: 'SPORT_TRAINER',
  SPORT_ATHLETE: 'SPORT_ATHLETE',
  DEO_DPEO: 'DEO_DPEO',
  DEO_DPEO_STAFF: 'DEO_DPEO_STAFF',
  AGENCY_MASTER_ADMIN: 'AGENCY_MASTER_ADMIN',
  JOB_SEEKER: 'JOB_SEEKER',
} as const;

export const APP_TYPE_USER_TYPES_MAP: Record<string, string[]> = {
  [DYNAMIC_APPTYPE.INSTITUTE_APP]: [
    USER_TYPE.INSTITUTE_MASTER_ADMIN,
    USER_TYPE.INSTITUTE_ADMIN,
    USER_TYPE.TEACHER,
  ],
  [DYNAMIC_APPTYPE.SCHOOL_APP]: [
    USER_TYPE.INSTITUTE_MASTER_ADMIN,
    USER_TYPE.INSTITUTE_ADMIN,
    USER_TYPE.TEACHER,
  ],
  [DYNAMIC_APPTYPE.GLOBAL_APP]: [
    USER_TYPE.MASTER_ADMIN,
    USER_TYPE.ADMIN,
  ],
  [DYNAMIC_APPTYPE.STUDENT_APP]: [
    USER_TYPE.STUDENT,
    USER_TYPE.PARENTS,
  ],
  [DYNAMIC_APPTYPE.VENDOR_APP]: [
    USER_TYPE.VENDOR,
  ],
  [DYNAMIC_APPTYPE.ARENA_APP]: [
    USER_TYPE.SPORT_INSTITUTE_OWNER,
    USER_TYPE.SPORT_TRAINER,
    USER_TYPE.SPORT_ATHLETE,
  ],
  [DYNAMIC_APPTYPE.COLLEGE_APP]: [
    USER_TYPE.INSTITUTE_MASTER_ADMIN,
    USER_TYPE.INSTITUTE_ADMIN,
    USER_TYPE.TEACHER,
  ],
  [DYNAMIC_APPTYPE.ALUMNI_APP]: [
    USER_TYPE.STUDENT,
  ],
  [DYNAMIC_APPTYPE.KIPIGOVT_APP]: [
    USER_TYPE.DEO_DPEO,
    USER_TYPE.DEO_DPEO_STAFF,
  ],
  [DYNAMIC_APPTYPE.DOCTOR_APP]: [
    USER_TYPE.INSTITUTE_MASTER_ADMIN,
    USER_TYPE.INSTITUTE_ADMIN,
  ],
  [DYNAMIC_APPTYPE.ADMISSIONS_AGENCY_APP]: [
    USER_TYPE.AGENCY_MASTER_ADMIN,
  ],
  [DYNAMIC_APPTYPE.EXPO_APP]: [
    USER_TYPE.INSTITUTE_MASTER_ADMIN,
    USER_TYPE.INSTITUTE_ADMIN,
  ],
};

export const USER_TYPE_LABELS: Record<string, string> = {
  [USER_TYPE.MASTER_ADMIN]: 'Master Admin',
  [USER_TYPE.ADMIN]: 'Admin',
  [USER_TYPE.INSTITUTE_MASTER_ADMIN]: 'Institute Master Admin',
  [USER_TYPE.INSTITUTE_ADMIN]: 'Institute Admin',
  [USER_TYPE.TEACHER]: 'Teacher',
  [USER_TYPE.STUDENT]: 'Student',
  [USER_TYPE.PARENTS]: 'Parents',
  [USER_TYPE.DRIVER]: 'Driver',
  [USER_TYPE.VENDOR]: 'Vendor',
  [USER_TYPE.SPORT_INSTITUTE_OWNER]: 'Sport Institute Owner',
  [USER_TYPE.SPORT_TRAINER]: 'Sport Trainer',
  [USER_TYPE.SPORT_ATHLETE]: 'Sport Athlete',
  [USER_TYPE.DEO_DPEO]: 'DEO / DPEO',
  [USER_TYPE.DEO_DPEO_STAFF]: 'DEO / DPEO Staff',
  [USER_TYPE.AGENCY_MASTER_ADMIN]: 'Agency Master Admin',
  [USER_TYPE.JOB_SEEKER]: 'Job Seeker',
};

export const getUserTypesByAppType = (
  appType?: string,
): Array<{ value: string; label: string }> => {
  if (!appType) return [];
  const types = APP_TYPE_USER_TYPES_MAP[appType] || [];
  return types.map((type) => ({
    value: type,
    label: USER_TYPE_LABELS[type] || type,
  }));
};


